import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 23%;
    height: 140px;
    margin: auto auto 20px auto;
    background: ${theme.colors.white};
    /* background: red; */
    border-radius: ${theme.border.radius};
    box-shadow: 0px 3px 1px rgba(0, 0, 0, 0.1);
    transition: background ${theme.transition.default};
    cursor: pointer;

    a {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      height: 100%;
      border-radius: ${theme.border.radius};
      text-decoration: none;
      color: ${theme.colors.black};

      &:hover {
        color: ${theme.colors.white};
      }
    }

    button {
      background: none;
      width: 100%;
      height: 100%;
      cursor: pointer;
      transition: all ${theme.transition.default};

      > div {
        margin: auto;
      }

      &:hover {
        > p {
          color: ${theme.colors.white};
        }
      }
    }

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      width: 74px;
      height: 74px;
      background: linear-gradient(180deg, #02b971 0%, #017849 100%);
      border-radius: 50%;
    }

    p {
      font-family: ${theme.font.montserrat};
      font-weight: ${theme.font.normal};
      font-size: ${theme.font.sizes.xxxsmall};
      text-align: center;
    }

    &:hover {
      background: ${theme.colors.primary};
      color: ${theme.colors.white};

      div {
        background: ${theme.colors.white};

        svg path {
          fill: ${theme.colors.primary};
        }
      }
    }

    ${media.lessThan('medium')`
      width: 46%;
    `}
  `}
`
